export default function isSelectable(inputNode) {
    return inputNode.selectionStart != null;
}
